import { render } from "./filter-list-manual-deduct-add.vue?vue&type=template&id=ca367df6&scoped=true&ts=true"
import script from "./filter-list-manual-deduct-add.vue?vue&type=script&lang=ts"
export * from "./filter-list-manual-deduct-add.vue?vue&type=script&lang=ts"

import "./filter-list-manual-deduct-add.vue?vue&type=style&index=0&id=ca367df6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca367df6"]])

export default __exports__